// @ts-check

window.addEventListener('load', () => {
    // loop over all elements with the class weather-warnings-js-target
    const widgets = document.querySelectorAll('.weather-warnings-js-target');
    widgets.forEach((widget) => {
        // get emma id
        const emmaId = widget.getAttribute('data-emma-id');
        // fetch the data, which is html content, and add it to the target element
        fetch(`?type=916105&emmaId=${emmaId}`)
            .then((response) => {
                if (response.ok) return response.text();
                throw new Error('Network response was not ok.');
            })
            .then((res) => {
                widget.outerHTML = res;
                globalThis.initWeatherWarnings();
            });
    });
});